import * as React from 'react';

import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  allowClear?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      style,
      value,
      onChange,
      allowClear = true,
      disabled,
      ...props
    },
    ref,
  ) => {
    // Show clear button only when: has value AND not disabled AND allowClear is true
    const showClearButton = !!value && !disabled && allowClear;

    return (
      <div className="relative w-full">
        <input
          type={type}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={cn(
            'bg-background text-foreground ring-offset-background placeholder:text-muted-foreground/50 hover:border-primary focus-visible:border-primary border-border flex h-10 min-h-[40px] w-full rounded-[8px] border border-solid px-3 py-2 text-[14px] transition-colors duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-0 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
            showClearButton && 'pr-10', // Add padding for clear button
            className,
          )}
          style={{
            fontWeight: 400,
            fontSize: '14px',
            ...style,
          }}
          ref={ref}
          {...props}
        />
        {showClearButton && (
          <button
            type="button"
            aria-label="Clear value"
            onClick={() =>
              onChange?.({
                target: { value: '' },
              } as React.ChangeEvent<HTMLInputElement>)
            }
            className="text-muted-foreground/60 hover:bg-muted hover:text-muted-foreground absolute top-1/2 right-2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full transition-colors"
          >
            <span
              className="material-symbols-rounded"
              style={{ fontSize: 16 }}
            >
              close
            </span>
          </button>
        )}
      </div>
    );
  },
);
Input.displayName = 'Input';

export { Input };
